import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=9ca4493e&"
import script from "./Toggle.vue?vue&type=script&lang=ts&"
export * from "./Toggle.vue?vue&type=script&lang=ts&"
import style0 from "./Toggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
